import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TicketInviteComponent } from './ticket-invite.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { FGBSharedModule } from '@fgb/portal-component-library/src/lib/shared';
import { TicketInviteListComponent } from './ticket-invite-list/ticket-invite-list.component';

@NgModule({
  declarations: [TicketInviteComponent, TicketInviteListComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FGBSharedModule
  ],
  exports: [TicketInviteComponent],
})
export class TicketInviteModule {}
